var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('th',{class:_vm.showArrow ? _vm.$style.enableCursor : _vm.$style.disableCursor,on:{"click":function($event){return _vm.$emit('sort', _vm.column)}}},[_vm._t("default"),(_vm.showArrow)?_c('div',{class:_vm.sortOrder === 'ASC' ? _vm.$style.arrowUp : _vm.$style.arrowDown}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }